import { render, staticRenderFns } from "./MinPa.vue?vue&type=template&id=5a37fb2b&scoped=true&"
import script from "./MinPa.vue?vue&type=script&lang=js&"
export * from "./MinPa.vue?vue&type=script&lang=js&"
import style0 from "./MinPa.vue?vue&type=style&index=0&id=5a37fb2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37fb2b",
  null
  
)

export default component.exports